import { rankingItems } from '@/mocks/home';

const coverImages: Record<string, string> = {
  'rank-01': 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20style%20illustration%20featuring%20dramatic%20character%20pose%20with%20dynamic%20action%20lines%20warm%20vibrant%20orange%20and%20red%20color%20scheme%20japanese%20anime%20manga%20aesthetic%20clean%20composition%20professional%20comic%20book%20cover%20design%20with%20bold%20typography%20space&width=128&height=160&seq=rank-01&orientation=portrait',
  'rank-02': 'https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20art%20style%20fantasy%20character%20with%20flowing%20hair%20and%20mysterious%20expression%20dramatic%20lighting%20in%20warm%20amber%20tones%20anime%20illustration%20with%20detailed%20linework%20and%20dynamic%20composition&width=128&height=160&seq=rank-02&orientation=portrait',
  'rank-03': 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20featuring%20fierce%20warrior%20character%20in%20battle%20stance%20with%20sword%20surrounded%20by%20flame%20effects%20warm%20orange%20red%20palette%20professional%20anime%20style%20cover%20art%20with%20aggressive%20dynamic%20pose&width=128&height=160&seq=rank-03&orientation=portrait',
  'rank-04': 'https://readdy.ai/api/search-image?query=Manga%20romance%20comic%20cover%20art%20featuring%20beautiful%20female%20character%20with%20fox%20ears%20and%20flowing%20hair%20in%20traditional%20dress%20soft%20warm%20peach%20and%20coral%20tones%20anime%20illustration%20style%20elegant%20composition&width=128&height=160&seq=rank-04&orientation=portrait',
  'rank-05': 'https://readdy.ai/api/search-image?query=Manga%20esports%20gaming%20comic%20cover%20featuring%20confident%20young%20character%20with%20gaming%20headset%20dynamic%20action%20pose%20with%20keyboard%20and%20mouse%20warm%20orange%20accents%20professional%20anime%20cover%20art%20style&width=128&height=160&seq=rank-05&orientation=portrait',
  'rank-06': 'https://readdy.ai/api/search-image?query=Manga%20historical%20martial%20arts%20comic%20cover%20art%20featuring%20rugged%20warrior%20character%20in%20desert%20landscape%20with%20weapon%20dynamic%20dramatic%20pose%20warm%20earthy%20orange%20tones%20anime%20style%20illustration&width=128&height=160&seq=rank-06&orientation=portrait',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门榜单</h2>
          <p className="text-sm md:text-base text-foreground-500">全网漫画热度排行，看看大家都在追什么</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl hover:bg-primary-50/40 transition-colors group cursor-pointer"
            >
              <div className="relative w-16 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={coverImages[item.coverSeq]}
                  alt={`${item.title} 漫画封面`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute top-0 left-0 w-6 h-6 bg-accent-500 text-background-50 text-xs font-bold flex items-center justify-center rounded-br-lg">
                  {item.rank}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-semibold text-foreground-950 text-sm md:text-base truncate group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap flex-shrink-0">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mb-1">{item.author}</p>
                <div className="flex items-center gap-1 text-xs text-accent-500">
                  <i className="ri-fire-line"></i>
                  <span>{item.heat}人气</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}